<div class="heading">
  <h2>کیفیت و پوشش زمانی داده‌ها</h2>
  <small>زمان مشاهده‌شده در مقابل بازه‌های بدون پوشش</small>
</div>

<ng-container *ngIf="quality; else empty">
  <div class="coverage-heading">
    <strong>درصد پوشش گزارش‌شده</strong>
    <strong dir="ltr" *ngIf="view.coverage != null; else unavailable">{{ view.coverage | number:'1.1-1':'en-US' }}%</strong>
  </div>
  <div class="coverage-bar" *ngIf="view.knownShare != null; else noCoverage" role="meter"
    aria-label="سهم زمان دارای پوشش از مجموع زمان ثبت‌شده" aria-valuemin="0" aria-valuemax="100" [attr.aria-valuenow]="view.knownShare">
    <div class="known" [style.width.%]="view.knownShare"></div>
    <div class="unknown" [style.width.%]="view.unknownShare"></div>
  </div>
  <ng-template #noCoverage><div class="coverage-unavailable">اطلاعات زمانی کافی برای نمایش نوار موجود نیست.</div></ng-template>
  <div class="legend">
    <span><i class="known" aria-hidden="true"></i>دارای پوشش</span>
    <span><i class="unknown" aria-hidden="true"></i>زمان نامشخص</span>
  </div>
  <p class="coverage-caption">نوار، سهم مجموع زمان‌ها را نشان می‌دهد؛ محل زمانی وقفه‌ها را نمایش نمی‌دهد.</p>

  <div class="metrics">
    <div class="metric-row"><span>زمان دارای پوشش</span><strong dir="ltr">{{ view.knownDuration }}</strong></div>
    <div class="metric-row"><span>زمان نامشخص</span><strong dir="ltr">{{ view.unknownDuration }}</strong></div>
    <div class="metric-row" *ngFor="let row of view.rows">
      <span>{{ row.label }}</span>
      <strong dir="ltr" *ngIf="row.value != null; else unavailable">{{ row.value | number:'1.0-0':'en-US' }}</strong>
    </div>
  </div>
  <p class="hint">بخش خاکستری نشان‌دهندهٔ زمان نامشخص است و به معنای خاموش بودن موتور نیست.</p>
</ng-container>

<ng-template #empty><div class="empty" role="status">اطلاعاتی برای بررسی کیفیت و پوشش زمانی داده‌ها موجود نیست.</div></ng-template>
<ng-template #unavailable><span class="unavailable" aria-label="اطلاعات موجود نیست">—</span></ng-template>
